/**
 * Home View
 */
export default () => ({

  title: 'Dashboard',

  getComponent(nextState, cb) {
    require.ensure(
      [],
      (require) => {
        const Home = require('./containers/DashboardContainer').default
        const AlertStatusBar = require('../../components/AlertsStatusBar').default
        const ToolbarFilters = require('../../components/ToolbarFilters').default
        cb(null, {
          content: Home,
          statusBar: AlertStatusBar,
          toolbarFilters: ToolbarFilters
        })
      },
      'home'
    )
  },
})



// WEBPACK FOOTER //
// ./src/routes/Home/index.js